/* eslint-disable no-use-before-define */
/* eslint-disable react/no-array-index-key */
import React, { FC } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';

import { useTranslate } from 'hooks/useTranslate';
import ToggleMenu from 'modules/_shared/components/ToggleMenu';

export type DocumentType = 'EMAIL' | 'PDF' | 'TEMPLATE' | 'OTHER';

export type DocumentsGroupItem = {
  name: string;
  size: number | null;
  date: string;
  description: string;
  content: any;
  contentType: DocumentType;
  isPublic?: boolean;
};

type CouncilMembersDocumentsCardGroupProps = {
  title: string;
  items: DocumentsGroupItem[];
  isAdmin: boolean; // eslint-disable-line no-unused-vars
  onEdit?: () => void; // eslint-disable-line no-unused-vars
  menuOptions?: React.ReactNode[];
  onSeeDocument?: (item: DocumentsGroupItem) => void; // eslint-disable-line no-unused-vars
  getMenuOptionsForItem?: (
    item: DocumentsGroupItem, // eslint-disable-line no-unused-vars
    index: number // eslint-disable-line no-unused-vars
  ) => React.ReactNode[];
};

export enum ContentTypes {
  EMAIL = 'EMAIL', // eslint-disable-line
  PDF = 'PDF', // eslint-disable-line
  TEMPLATE = 'TEMPLATE', // eslint-disable-line
  OTHER = 'OTHER', // eslint-disable-line
}

const getIconByContentType = (contentType: DocumentType) => {
  switch (contentType) {
    case 'EMAIL':
      return 'ni ni-mail text-soft';
    case 'PDF':
      return 'ni ni-file-pdf text-danger';
    case 'OTHER':
      return 'ni ni-notes-alt text-soft';
    default:
      return 'ni ni-notes-alt text-soft';
  }
};

const CouncilMembersDocumentsCardGroup: FC<
  CouncilMembersDocumentsCardGroupProps
> = ({
  title,
  items,
  isAdmin: _isAdmin, // eslint-disable-line no-unused-vars
  onEdit: _onEdit, // eslint-disable-line no-unused-vars
  menuOptions = [],
  onSeeDocument,
  getMenuOptionsForItem,
}) => {
  const { t } = useTranslate();

  const getItemStyle = (item: DocumentsGroupItem) => {
    if (!item.content || !item.isPublic) {
      return 'data-item';
    }

    return 'data-item';
  };

  const getMenuOptionsForItemInternal = (
    item: DocumentsGroupItem,
    itemIndex: number
  ) => {
    // Use custom function if provided
    if (getMenuOptionsForItem) {
      return getMenuOptionsForItem(item, itemIndex);
    }

    // Fallback to default behavior
    if (menuOptions.length === 0) return [];

    return menuOptions.map((option, index) => {
      // Clone the option and update the onClick to work with the specific item
      if (
        React.isValidElement(option) &&
        option.key === 'see' &&
        onSeeDocument
      ) {
        return (
          <Dropdown.Item
            key={`see-${index}`}
            onClick={() => onSeeDocument(item)}
          >
            {t('See')}
          </Dropdown.Item>
        );
      }
      return option;
    });
  };

  return (
    <>
      <div className="nk-block-head">
        <div className="nk-block-head-content d-flex justify-content-between align-items-center">
          <h5 className="nk-block-title title mb-0">{title}</h5>

          {/* {isAdmin && (
            <EditButton className="" action={onEdit} disabled={!onEdit} />
          )} */}
        </div>
      </div>

      <div className="card rounded-xl">
        <ul className="data-list is-compact">
          {items.map((item, index) => (
            <li
              className={getItemStyle(item)}
              key={`${item.name}-${index}`}
              // onClick={() => handleClickDocument(item)}
            >
              <div className="data-col d-flex align-items-center">
                <div className="document-icon mr-3 flex-shrink-0">
                  <em
                    className={`icon fs-5 ${getIconByContentType(
                      item.contentType
                    )}`}
                  />
                </div>

                <div className="data-col flex-grow-1 min-w-500px mw-75 g-2">
                  <div className="data-value fw-medium text-truncate mr-2">
                    {item.name}
                  </div>
                  <small className="data-label text-muted text-nowrap">
                    {item.isPublic ? (
                      <>
                        {item.description}
                        {item.contentType !== ContentTypes.EMAIL && (
                          <>{item.size ? <> | {item.size} MB</> : null}</>
                        )}
                      </>
                    ) : (
                      <>{t('ThisDocumentIsPrivate')}</>
                    )}
                  </small>
                </div>

                <div className="data-col text-nowrap flex-shrink-0 w-80px mr-3">
                  {item.isPublic && (
                    <div className="sub-text">{item.date || '-'}</div>
                  )}
                </div>

                <div className="data-col text-nowrap flex-shrink-0 position-relative">
                  {getMenuOptionsForItemInternal(item, index).length > 0 && (
                    <ToggleMenu
                      toggleOptions={getMenuOptionsForItemInternal(item, index)}
                    />
                  )}
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default CouncilMembersDocumentsCardGroup;
